import { IcStar, ReviewScoreTypography, Typography } from '@musinsa/mds';
import type { FC } from 'react';

const DISPLAY_NAME = 'ProductInformation.ReviewScore';

interface Props {
  reviewScore: string;
}

export const ReviewScore: FC<Props> = ({ reviewScore }) => (
  <>
    <IcStar fillColor="yellow" width="12px" height="12px" />
    <Typography variant="textEtc11pxReg" colorScheme="yellow">
      {reviewScore !== '0.0' ? <ReviewScoreTypography reviewScore={Number(reviewScore)} /> : '0.0'}
    </Typography>
  </>
);

ReviewScore.displayName = DISPLAY_NAME;
